import type { MouseEvent, ReactNode } from 'react';
import { Anchor, Paragraph } from '@zillow/constellation-10';
import Bullet from '../../Bullet';
import Timestamp from '../../Timestamp';

type Props = {
  ctaText?: string;
  message: string;
  messageDateMs?: string;
  onCtaClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  renderLink?: (children: ReactNode) => ReactNode;
  url?: string;
};

export default function LowPrioritySystemMessage({
  ctaText,
  message,
  messageDateMs,
  onCtaClick,
  renderLink,
  url,
}: Props): JSX.Element {
  const shouldShowCta = ctaText && url;
  const hasMessageDateMs = !!messageDateMs;

  return (
    <Paragraph textStyle="body-xs" css={{ textAlign: 'center' }}>
      <span>{message}</span>
      {shouldShowCta && (
        <>
          <span> &nbsp; </span>
          {renderLink ? (
            renderLink(ctaText)
          ) : (
            <Anchor
              href={url}
              target={onCtaClick ? undefined : '_blank'}
              onClick={onCtaClick}
              css={{ whiteSpace: 'nowrap' }}
            >
              {ctaText}
            </Anchor>
          )}
        </>
      )}
      {hasMessageDateMs && (
        <>
          <Bullet />
          <Timestamp color="text.neutral" messageDateMs={messageDateMs} />
        </>
      )}
    </Paragraph>
  );
}
